import PageHero from "@/components/jf/PageHero";
import Collections from "@/components/jf/Collections";
import Clientele from "@/components/jf/Clientele";

export default function SpacesPage() {
  return (
    <main>
      <PageHero
        kicker="Portfolio"
        title={<>Spaces we've <em className="text-brass-soft font-light">furnished.</em></>}
        accent="08+"
      >
        <p className="mt-8 max-w-xl text-ivory/70 font-light leading-relaxed text-base md:text-lg">
          Cafés, restaurants, hotels, villas, residences, flats, lounges and commercial
          spaces — furnished end to end by our own factory.
        </p>
      </PageHero>
      <Collections />
      <Clientele />
    </main>
  );
}
